import React, { useState, useEffect } from "react";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";

const SettlementModal = ({ invoice, onClose, onSuccess }) => {
  const [netAmount, setNetAmount] = useState(0); 
  const [pgCharges, setPgCharges] = useState(0);
  const [bankName, setBankName] = useState("HDFC Bank Account");
  const [loading, setLoading] = useState(false);

  // NEW: Identify if this is a Razorpay transaction
  const isOnlinePayment = invoice.transactionType === "Online-Razorpay";

  const handleSubmit = async () => {
    const received = parseFloat(netAmount) || 0;
    const charges = parseFloat(pgCharges) || 0;

    if (received <= 0) return alert("Please enter the amount received.");

    setLoading(true);
    try {
      const payload = {
        companyId: invoice.companyId,
        // Using invoiceNumber as the link for manual invoices
        bookingId: invoice.bookingId || invoice.invoiceNumber, 
        netSettledAmount: received,
        pgCharges: charges,
        bankAccountName: bankName
      };

      await apiService.post(config.SETTLEPAYMENT, payload);
      onSuccess(); 
      onClose();
    } catch (error) {
      alert("Failed to record transaction");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>{isOnlinePayment ? "Settle Razorpay" : "Record Payment Receipt"}</h3>
        <p className="mb-1">Invoice: <strong>{invoice.invoiceNumber}</strong></p>
        <p>Total Amount: <strong>INR {invoice.grandTotal}</strong></p>

        <div className="form-group">
          <label>Deposit To (Bank/Cash Account)</label>
          <select className="form-select" value={bankName} onChange={(e) => setBankName(e.target.value)}>
            <option value="HDFC Bank Account">HDFC Bank Account</option>
            <option value="Cash Account">Cash Account</option>
            <option value="Office Petty Cash">Office Petty Cash</option>
          </select>
        </div>

        <div className="form-group">
          <label>{isOnlinePayment ? "Net Amount Received in Bank" : "Amount Received (Installment)"}</label>
          <input 
            type="number" 
            className="form-control highlight-input" 
            placeholder="0.00"
            value={netAmount} 
            onChange={(e) => setNetAmount(e.target.value)} 
          />
        </div>

        {/* NEW: Only show or enable PG Charges if it is an Online Payment */}
        {isOnlinePayment && (
          <div className="form-group">
            <label>PG Charges (Deducted by Razorpay)</label>
            <input 
              type="number" 
              className="form-control" 
              value={pgCharges} 
              onChange={(e) => setPgCharges(e.target.value)} 
            />
          </div>
        )}

        <div className="info-summary mt-2">
           <small>This will credit Agent's account by: </small>
           <strong className="text-success">INR {(parseFloat(netAmount || 0) + parseFloat(pgCharges || 0)).toFixed(2)}</strong>
        </div>

        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button className="btn btn-success" onClick={handleSubmit} disabled={loading}>
            {loading ? "Saving..." : "Confirm Payment"}
          </button>
        </div>
      </div>

      <style jsx>{`
        .modal-overlay {
          position: fixed; top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(0,0,0,0.6); display: flex; justify-content: center; align-items: center;
          z-index: 2000;
        }
        .modal-content {
          background: white; padding: 25px; border-radius: 12px; width: 450px; box-shadow: 0 10px 25px rgba(0,0,0,0.2);
        }
        .highlight-input { border: 2px solid #28a745; font-size: 18px; font-weight: bold; }
        .form-group { margin-bottom: 15px; }
        .form-group label { font-weight: 600; font-size: 13px; color: #555; display: block; margin-bottom: 5px; }
        .modal-actions { display: flex; justify-content: flex-end; gap: 10px; margin-top: 25px; }
        .info-summary { padding: 10px; background: #f8f9fa; border-radius: 6px; border-left: 4px solid #28a745; }
      `}</style>
    </div>
  );
};

export default SettlementModal;